//interface
import { IBatchRequestResponse } from "models/Batch";
import { IQuoteDetailItem } from "models/QuoteDetailItem";
//utils
import { IsNullOrEmpty } from "utils/StringNullOrEmpty";

export const ToCommaDecimals = (value: number, decimals?: number) => {
    if (value) {
      const valueComma = value?.toString().replace(/[.]/, ",");
      const commaIndex = valueComma.indexOf(",");
      if (commaIndex > 0 && decimals) {
        return valueComma.substr(0, commaIndex + decimals + 1);
      } else {
        return valueComma;
      }
    } else {
      return "-";
    }
  };

export const ExistsDuplicatedItem = (item: any, quoteItem: IBatchRequestResponse<IQuoteDetailItem> | undefined ) => {
  if(!quoteItem) return false;

  const itemDuplicated = quoteItem?.data?.filter(x => x.sequenceNumber === item.sequenceNumber && !x.budgets?.deleted);
  return (itemDuplicated && itemDuplicated.length > 1 && (item.budgets?.sequence === 0 || IsNullOrEmpty(item.budgets))) ?? false;
}